module.exports = __webpack_public_path__ + "img/fullscreen_exit.c223388f.svg";